import { IObservable, Subject } from '~/rage/utils';
import { IPlayerCharacter, PlayerCharacterPreview } from '~/shared';
import { ICharacterSelectionService } from './characterSelectionServiceTypes';

export class CharacterSelectionServiceStub
	implements ICharacterSelectionService
{
	private characters = new Subject<Array<IPlayerCharacter | null>>([
		{
			id: '112',
			name: 'Maxvolla',
			level: 15,
			totalMoneyAmount: 1000000,
			lastEnteredAt: 1716153600000,
			banReason: 'Курил кальян без елок',
			appearance: null,
			banExpiresAt: null,
			clothes: null,
			tattoos: null,
		},
		null,
		{
			id: '1112',
			name: 'Maxvolla',
			level: 15,
			totalMoneyAmount: 1000000,
			lastEnteredAt: 1716153600000,
			banExpiresAt: Date.now() + 5 * 24 * 60 * 60 * 1000,
			appearance: null,
			clothes: null,
			tattoos: null,
		},
	]);
	private login = new Subject<string>('Maxvolla');
	private pricePerCharacter = new Subject<number[]>([0, 0, 500]);
	private maxCharacters = new Subject<number>(3);

	constructor() {
		this.getCharacters().subscribe((characters) => {
			if (!characters) return;
			this.handleCharactersUpdate(characters);
		});
	}

	private async handleCharactersUpdate(
		characters: Array<IPlayerCharacter | null>,
	): Promise<void> {
		const previewCharacters = characters.map((character) => {
			if (!character) {
				return null;
			}

			const { appearance, clothes, tattoos } = character;
			return { appearance, clothes, tattoos };
		});

		await this.setCharactersToPreview(previewCharacters);
	}

	public getCharacters(): IObservable<Array<IPlayerCharacter | null> | null> {
		return this.characters;
	}

	public getPricePerCharacter(): IObservable<number[]> {
		return this.pricePerCharacter;
	}

	public getMaxCharacters(): IObservable<number> {
		return this.maxCharacters;
	}

	public async createCharacter(characterSlotIndex: number): Promise<void> {
		console.log('auth:createCharacter', { characterSlotIndex });
	}

	public async selectCharacter(characterId: string): Promise<void> {
		console.log('auth:selectCharacter', { characterId });
	}

	public async setCurrentIndex(index: number): Promise<void> {
		console.log('characterSelection:setCurrentIndex', { index });
	}

	private async setCharactersToPreview(
		characters: PlayerCharacterPreview[],
	): Promise<void> {
		console.log('characterSelection:setCharactersToPreview', { characters });
	}

	public getAccountLogin(): IObservable<string> {
		return this.login;
	}
}
